import React, { useState } from 'react'
import {
  MdDashboard,
  MdPayment,
  MdBedroomParent,
  MdOutlineMeetingRoom,
  MdPeople,
  MdKeyboardArrowDown,
} from 'react-icons/md'
import './Sidebar.css'
import { NavLink } from 'react-router-dom'

export default function Sidebar({ isOpen, toggleSidebar, role }) {

  console.log("Sidebar rendered");
  console.log("Role =", role);
  const [activeItem, setActiveItem] = useState('Dashboard')
  const [openDropdown, setOpenDropdown] = useState(null)

  // ============================
  // ROLE-WISE MENUS
  // ============================

  const adminMenu = [
    { title: 'Dashboard', icon: <MdDashboard />, path: '/admin/dashboard' },

    {
      title: 'Masters',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Class Master', path: '/admin/masters/class' },
        { name: 'Room Master', path: '/admin/masters/rooms' },
        { name: 'Bed Master', path: '/admin/masters/beds' },
        { name: 'Religion Master', path: '/admin/masters/religion' },
        { name: 'Caste Master', path: '/admin/masters/caste' },
        // { name: "Sub Caste Master", path: "/admin/masters/sub-caste" },
        { name: 'Event Master', path: '/admin/masters/events' },
        { name: 'Fee Master', path: '/admin/masters/fee' },
        { name: 'Fee Amount Master', path: '/admin/masters/fee-amt' },
        {
          name: 'Terms & Condition Master',
          path: '/admin/masters/terms-condition',
        },
        { name: 'Job Category Master', path: '/admin/masters/category' },
      ],
    },

    {
      title: 'Approval Pending',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Reg. Approval Pending List', path: '/admin/reg-app-pending' },
        { name: 'Rejected Student List', path: '/admin/reject-stud' },
        { name: 'Document Approval Pending', path: '/admin/document-pending',},
        { name: 'Document Rejected List', path: '/admin/document-rejected', },
        { name: 'Pending Interviews List', path: '/admin/pend-interv' },
        { name: 'Hostel Fee Approval Pending List', path: '/admin/fee-app-pending', },
        { name: 'Pending Room Allotment List', path: '/admin/room-allot-pending', },
        
        {
          name: 'Leave Approval Pending List',
          path: '/admin/leave-app-pending',
        },
        {
          name: 'Complaint Approval Pending List',
          path: '/admin/complaint-app-pending',
        },
        {
          name: 'Alumni Approval Pending List',
          path: '/admin/alumni-app-pending',
        },
        
      ],
    },

    {
      title: 'Admission',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Reg. Approved List', path: '/admin/reg-apprv' },
        { name: 'Document Approved List', path: '/admin/document-approved',},
        { name: 'Passed Interviews List', path: '/admin/pass-inter' },
        { name: 'Hostel Fee Approved List', path: '/admin/fee-apprv' },
        { name: 'Room Allocation List', path: '/admin/room-alloc' },
        { name: 'Leave Approved List', path: '/admin/leave-apprv' },
        {
          name: 'Concession Fee Approved List',
          path: '/admin/concession-fee-apprv',
        },
        { name: 'Alumni Approved List', path: '/admin/alumni-apprv' },
      ],
    },

    {
      title: 'Attendance',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: "Student's Daily Attendance", path: '/admin/attendance-daily' },
        { name: "Attended Student's List", path: '/admin/attendance-attended' },
        { name: 'Event Attendance', path: '/admin/event-attendance' },
        { name: 'Event Attended Student List', path: '/admin/event-attended' },
        { name: 'Mandir Attendance', path: '/admin/mandir-attendance' },
        {
          name: 'Mandir Attended Student List',
          path: '/admin/mandir-attended',
        },
      ],
    },

    {
      title: 'Room Change',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: "Student's Room Change", path: '/admin/room-change' },
        { name: 'Room Allotment List', path: '/admin/room-allotment' },
        { name: 'Room Changed History', path: '/admin/room-history' },
      ],
    },

    // { title: "Caste Certificate", icon: <MdDashboard />, path: "/admin/create-certificate" },

    // {
    //   title: 'Site Setting',
    //   icon: <MdOutlineMeetingRoom />,
    //   subItems: [{ name: 'Registration Control', path: '/admin/reg-control' }],
    // },

    { title: 'Job Post', icon: <MdDashboard />, path: '/admin/job-post' },
  ]

  const superintendentMenu = [
    {
      title: 'Dashboard',
      icon: <MdDashboard />,
      path: '/superintendent/dashboard',
    },

    {
      title: 'Masters',
      icon: <MdPayment />,
      subItems: [
        { name: 'Class Master', path: '/admin/masters/class' },
        { name: 'Room Master', path: '/superintendent/masters/rooms' },
        { name: 'Bed Master', path: '/superintendent/masters/beds' },
        { name: 'Religion Master', path: '/admin/masters/religion' },
        { name: 'Caste Master', path: '/superintendent/masters/caste' },
        // { name: "Sub Caste Master", path: "/superintendent/masters/sub-caste" },
        { name: 'Event Master', path: '/superintendent/masters/events' },
        { name: 'Fee Master', path: '/superintendent/masters/fee' },
        { name: 'Fee Amount Master', path: '/superintendent/masters/fee-amt' },
      ],
    },

    {
      title: 'Approval Pending',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        {
          name: 'Reg. Approval Pending List',
          path: '/superintendent/reg-app-pending',
        },
        { name: 'Reg. Approval Pending List', path: '/superintendent/reg-app-pending' },

        {
          name: 'Pending Interviews List',
          path: '/superintendent/pend-interv',
        },
        {
          name: 'Hostel Fee Approval Pending List',
          path: '/superintendent/fee-app-pending',
        },
        {
          name: 'Leave Approval Pending List',
          path: '/superintendent/leave-app-pending',
        },
        {
          name: 'Complaint Approval Pending List',
          path: '/superintendent/complaint-app-pending',
        },
      ],
    },

    {
      title: 'Admission',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Reg. Approved List', path: '/superintendent/reg-apprv' },
        { name: 'Passed Interviews List', path: '/superintendent/pass-inter' },
        { name: 'Hostel Fee Approved List', path: '/superintendent/fee-apprv' },
        { name: 'Leave Approved List', path: '/superintendent/leave-apprv' },
        { name: 'Room Allocation List', path: '/superintendent/room-alloc' },
      ],
    },

    {
      title: 'Attendance',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        {
          name: "Student's Daily Attendance",
          path: '/superintendent/attendance-daily',
        },
        {
          name: "Attended Student's List",
          path: '/superintendent/attendance-attended',
        },
        { name: 'Event Attendance', path: '/superintendent/event-attendance' },
        {
          name: 'Event Attended Student List',
          path: '/superintendent/event-attended',
        },
        { name: 'Mandir Attendance', path: '/admin/mandir-attendance' },
        {
          name: 'Mandir Attended Student List',
          path: '/admin/mandir-attended',
        },
      ],
    },

    {
      title: 'Room Change',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: "Student's Room Change", path: '/superintendent/room-change' },
        { name: 'Room Allotment List', path: '/superintendent/room-allotment' },
        { name: 'Room Changed History', path: '/superintendent/room-history' },
      ],
    },

    // { title: "Caste Certificate", icon: <MdDashboard />, path: "/superintendent/create-certificate" },
    // {
    //   title: 'Site Setting',
    //   icon: <MdOutlineMeetingRoom />,
    //   subItems: [
    //     { name: 'Registration Control', path: '/superintendent/reg-control' },
    //   ],
    // },
  ]

  const wardenMenu = [
    { title: 'Dashboard', icon: <MdDashboard />, path: '/warden/dashboard' },

    {
      title: 'Approval Pending',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Reg. Approval Pending List', path: '/warden/reg-app-pending' },
        { name: 'Reg. Approval Pending List', path: '/warden/reg-app-pending' },
        { name: 'Pending Interviews List', path: '/warden/pend-interv' },
        {
          name: 'Hostel Fee Approval Pending List',
          path: '/warden/fee-app-pending',
        },
        {
          name: 'Leave Approval Pending List',
          path: '/warden/leave-app-pending',
        },
        {
          name: 'Complaint Resolve Pending List',
          path: '/warden/complaint-app-pending',
        },
      ],
    },

    {
      title: 'Attendance',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        {
          name: "Student's Daily Attendance",
          path: '/warden/attendance-daily',
        },
        {
          name: "Attended Student's List",
          path: '/warden/attendance-attended',
        },
        { name: 'Event Attendance', path: '/warden/event-attendance' },
        { name: 'Event Attended Student List', path: '/warden/event-attended' },
        { name: 'Mandir Attendance', path: '/admin/mandir-attendance' },
        {
          name: 'Mandir Attended Student List',
          path: '/admin/mandir-attended',
        },
      ],
    },
    {
      title: 'Admission',
      icon: <MdOutlineMeetingRoom />,
      subItems: [
        { name: 'Reg. Approved List', path: '/warden/reg-apprv' },
        { name: 'Passed Interviews List', path: '/warden/pass-inter' },
        { name: 'Hostel Fee Approved List', path: '/warden/fee-apprv' },
        { name: 'Leave Approved List', path: '/warden/leave-apprv' },
        { name: 'Room Allocation List', path: '/warden/room-alloc' },
      ],
    },
  ]

  const officeMenu = [
  {
    title: 'Dashboard',
    icon: <MdDashboard />,
    path: '/office/dashboard',
  },

  {
    title: 'Approval Pending',
    icon: <MdOutlineMeetingRoom />,
    subItems: [
      {
        name: 'Registration Approval Pending',
        path: '/office/reg-app-pending',
      },
      {
        name: 'Rejected Reg Students List',
        path: '/office/reject-stud',
      },
      
      // {
      //   name: 'Interviews Pending List',
      //   path: '/office/pend-interv',
      // },
      {
        name: 'Hostel Fee Approval Pending',
        path: '/office/fee-app-pending',
      },
      // {
      //   name: 'Document Approval Pending',
      //   path: '/office/document-pending',
      // },
      //  {
      //   name: 'Document Rejected List',
      //   path: '/office/document-rejected',
      // },
    ],
  },

  {
    title: 'Admission',
    icon: <MdOutlineMeetingRoom />,
    subItems: [
      {
        name: 'Registration Approved List',
        path: '/office/reg-apprv',
      },
      // {
      //   name: 'Interviews Passed List',
      //   path: '/office/pass-inter',
      // },
      {
        name: 'Hostel Fee Approved List',
        path: '/office/fee-apprv',
      },
      // {
      //   name: 'Document Approved List',
      //   path: '/office/document-approved',
      // },
    ],
  },
]

  // SELECT MENU BASED ON ROLE
  let menuItems = []
  if (role === 'admin') menuItems = adminMenu
  else if (role === 'superintendent') menuItems = superintendentMenu
  else if (role === 'warden') menuItems = wardenMenu
  else if(role === 'office') menuItems = officeMenu

  const handleDropdownToggle = (title) => {
    setOpenDropdown(openDropdown === title ? null : title)
  }



  return (
    <>
      <div
        className={`overlay ${isOpen ? 'show' : ''}`}
        onClick={toggleSidebar}
      />

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="brand-text"></span>
          <button className="close-btn" onClick={toggleSidebar}>
            ✖
          </button>
        </div>

        <nav className="nav">
          {menuItems.map((item) => (
            <div key={item.title} className="menu-group">
              {/* If item is direct link */}
              {item.path ? (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-item ${isActive ? 'active' : ''}`
                  }
                  onClick={() => {
                    setActiveItem(item.title)
                    toggleSidebar()
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>
                </NavLink>
              ) : (
                <button
                  className={`nav-item ${
                    activeItem === item.title ? 'active' : ''
                  }`}
                  onClick={() => {
                    setActiveItem(item.title)
                    handleDropdownToggle(item.title)
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>

                  {item.subItems && (
                    <MdKeyboardArrowDown
                      className={`arrow ${
                        openDropdown === item.title ? 'rotate' : ''
                      }`}
                    />
                  )}
                </button>
              )}

              {/* Dropdown */}
              {item.subItems && openDropdown === item.title && (
                <div className="submenu flat">
                  {item.subItems.map((sub) => (
                    <NavLink
                      key={sub.name}
                      to={sub.path}
                      className={({ isActive }) =>
                        `submenu-item ${isActive ? 'active' : ''}`
                      }
                      onClick={toggleSidebar}
                    >
                      <span className="submenu-dot">•</span>
                      {sub.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  )


}
